import { createIcon } from "@chakra-ui/icons";

const Expand01 = createIcon({
  displayName: "Expand01",
  viewBox: "0 0 24 24",
  path: [
    <path
      d="M14 10L21 3M21 3H15M21 3V9M10 14L3 21M3 21H9M3 21L3 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      key="jtIn"
    ></path>,
  ],
  defaultProps: { boxSize: 4 },
});

export default Expand01;
